import { render } from "./CommunityTalkUser.vue?vue&type=template&id=3462b574&ts=true"
import script from "./CommunityTalkUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkUser.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkUser.vue?vue&type=style&index=0&id=3462b574&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CommunityTalkUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3462b574"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3462b574', __exports__)) {
    api.reload('3462b574', __exports__)
  }
  
  module.hot.accept("./CommunityTalkUser.vue?vue&type=template&id=3462b574&ts=true", () => {
    api.rerender('3462b574', render)
  })

}


export default __exports__